
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import HowItWorks from "@/components/HowItWorks";
import WhatWeDo from "@/components/WhatWeDo";
import WhosItFor from "@/components/WhosItFor";
import DownloadManager from "@/components/DownloadManager";
import KeyFeatures from "@/components/KeyFeatures";
import CallToAction from "@/components/CallToAction";
import FAQ from "@/components/FAQ";
import EnhancedFooter from "@/components/EnhancedFooter";

const Index = () => {
  return (
    <div className="min-h-screen bg-[#0F111A]">
      <Header />
      <main>
        <HeroSection />
        <HowItWorks />
        <WhatWeDo />
        <WhosItFor />
        <DownloadManager />
        <KeyFeatures />
        <CallToAction />
        <FAQ />
      </main>
      <EnhancedFooter />
    </div>
  );
};

export default Index;
